import { SterBanner } from '@bnnvara/ster';
import { useRouter } from 'next/router';
import React from 'react';

const ComposableSterBanner = (props) => {
  const { route } = useRouter();

  return <SterBanner page={route} {...props} />;
};

export default ComposableSterBanner;
